<template>
  <div class="project-listing-kanban-toggle">
    <template v-if="isKanban">
      <el-tooltip placement="bottom">
        <template #content>
          <div>List View</div>
        </template>
        <div class="toggle-option listing marker--project-listing-kanban-toggle--listing" @click="goToListing">
          <i class="ddi ddi-list" />
        </div>
      </el-tooltip>
      <el-tooltip placement="bottom">
        <template #content>
          <div>Kanban View</div>
        </template>
        <div class="active toggle-option kanban marker--project-listing-kanban-toggle--kanban">
          <i class="ddi ddi-kanban" />
        </div>
      </el-tooltip>
    </template>
    <template v-else>
      <el-tooltip placement="bottom">
        <template #content>
          <div>List View</div>
        </template>
        <div class="active toggle-option listing marker--project-listing-kanban-toggle--listing">
          <i class="ddi ddi-list" />
        </div>
      </el-tooltip>
      <el-tooltip placement="bottom">
        <template #content>
          <div>Kanban View</div>
        </template>
        <div class="toggle-option kanban marker--project-listing-kanban-toggle--kanban" @click="goToKanban">
          <i class="ddi ddi-kanban" />
        </div>
      </el-tooltip>
    </template>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import RouteAssistant from '@/helpers/route-assistant'

export default defineComponent({
  name: 'ProjectListingKanbanToggle',

  props: {
    isKanban: {
      type: Boolean,
      default: false,
    },
    isMailbox: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      RouteAssistant,
    }
  },

  methods: {
    goToListing() {
      if (this.isMailbox) {
        RouteAssistant.goToMailboxListing(
          this.$router,
          this.$route.params.accountId,
          this.$route.params.id,
          this.$route.params.name,
        )
      } else {
        RouteAssistant.goToProjectListing(
          this.$router,
          this.$route.params.accountId,
          this.$route.params.id,
          this.$permissions,
        )
      }
    },
    goToKanban() {
      if (this.isMailbox) {
        RouteAssistant.goToMailboxKanban(
          this.$router,
          this.$route.params.accountId,
          this.$route.params.id,
        )
      } else {
        RouteAssistant.goToProjectKanban(
          this.$router,
          this.$route.params.accountId,
          this.$route.params.id,
          this.$permissions,
        )
      }
    },
  },
})
</script>

<style lang="scss">
.project-listing-kanban-toggle {
  display: flex;
  color: var(--color-text-third);
  cursor: pointer;
  width: 64px;
  height: 26px;

  .toggle-option {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 36px;
    font-size: 12px;
    border-style: solid;
    border-color: var(--color-text-third);

    &.listing {
      border-top-left-radius: 4px;
      border-bottom-left-radius: 4px;
      border-width: 1px;
    }

    &.kanban {
      border-top-right-radius: 4px;
      border-bottom-right-radius: 4px;
      border-width: 1px 1px 1px 0;
    }
  }

  .active {
    color: $color--white;
    cursor: default;
    background: $color--gray-60;
  }
}
</style>
